export enum AuthTypeEnum{
    system = 0,
    openIDConnect = 1
}
